/**
 * ⚙️ All tunable map parameters — adjust here, not in components.
 */
export const MAP_CONFIG = {
  trajectoryPointRadius: 5,
  trajectoryLineWidth: 2,
  teamMarkerSize: 1.0,
  landingMarkerSize: 1.2,
  fitBoundsPaddingPx: 40,
  fitBoundsExpand: 0.01,
  fitBoundsDurationMs: 500,
  // Divisor applied to single-point zoom helpers (zoomToBalloon, zoomToNormalLanding,
  // zoomToInstantLanding). Values > 1 reduce the effective zoom level, zooming out
  // further — useful to avoid "Map data not yet available" on satellite tiles at high zoom.
  singlePointZoomFactor: 1.0,
  // Default map viewport used when no session is saved (§23b).
  initialViewState: {
    longitude: 2.35,
    latitude:  46.8,
    zoom:      5,
    pitch:     0,
    bearing:   0,
  },
};
